import { render, staticRenderFns } from "./SubCategoryBox.vue?vue&type=template&id=417a55ac&"
import script from "./SubCategoryBox.js?vue&type=script&lang=js&"
export * from "./SubCategoryBox.js?vue&type=script&lang=js&"
import style0 from "./SubCategoryBox.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports